import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import ErrorNotification from './ErrorNotification';

/* eslint-disable jsx-a11y/no-onchange */
const SelectCategorie = ({ formik, categorie, updateSottocategorie }) => (
	<div className="column is-full-mobile is-half-tablet">
		<label htmlFor="categorie" className="label">
			Categoria Servizio
			<div className="select is-fullwidth">
				<select
					name="categorie"
					id="categorie"
					className="is-fullwidth has-background-white-bis"
					{...formik.getFieldProps('categorie')}
					onChange={(e) => {
						formik.handleChange('categorie')(e);
						updateSottocategorie(e);
					}}
				>
					{categorie}
				</select>
			</div>
		</label>
		<ErrorNotification formik={formik} field="categorie" />
	</div>
);
/* eslint-enable jsx-a11y/no-onchange */

SelectCategorie.propTypes = {
	formik: PropTypes.instanceOf(Object).isRequired,
	categorie: PropTypes.instanceOf(Array).isRequired,
	updateSottocategorie: PropTypes.instanceOf(Function).isRequired,
};

const SelectSottocategorie = ({ formik, sottocategorie }) => (
	<div className="column is-full-mobile is-half-tablet">
		<label htmlFor="sottocategorie" className="label">
			Sottocategoria Servizio
			<div className="select is-fullwidth">
				<select
					name="sottocategorie"
					id="sottocategorie"
					className="is-fullwidth has-background-white-bis"
					{...formik.getFieldProps('sottocategorie')}
				>
					{sottocategorie}
				</select>
			</div>
		</label>
		<ErrorNotification formik={formik} field="sottocategorie" />
	</div>
);

SelectSottocategorie.propTypes = {
	formik: PropTypes.instanceOf(Object).isRequired,
	sottocategorie: PropTypes.instanceOf(Array).isRequired,
};

const createOptions = (items) => {
	const options = [];
	options.push(<option aria-label="empty-option" />);

	const categoriesToExclude = ['Assicurazione', 'Senza Categoria'];

	items.forEach(function (categoria) {
		if (!categoriesToExclude.includes(categoria.name)) {
			options.push(
				<option key={categoria.term_id} value={categoria.name}>
					{categoria.name}
				</option>
			);
		}
	});

	return options;
};

const SelectContainer = ({ formik }) => {
	const [categoriePrincipali, setCategorie] = useState([]);
	const [sottocategorie, setSottoCategorie] = useState([]);
	const updateSottocategorie = (event) => {
		const name = event.target.value;
		const fetchData = async () => {
			const result = await axios(
				`${window.location.origin}/wp-json/telepass-v1/get_subcategorie?term_name=${name}`
			);
			setSottoCategorie(createOptions(result.data.terms, {}));
		};
		fetchData();
	};
	useEffect(() => {
		const fetchData = async () => {
			const result = await axios(
				`${window.location.origin}/wp-json/telepass-v1/get_macrocategorie`
			);
			setCategorie(createOptions(result.data.terms, {}));
		};
		fetchData();
	}, []);
	return (
		<div className="columns is-flex is-multiline">
			<SelectCategorie
				categorie={categoriePrincipali}
				updateSottocategorie={updateSottocategorie}
				formik={formik}
			/>
			<SelectSottocategorie
				sottocategorie={sottocategorie}
				formik={formik}
			/>
		</div>
	);
};

SelectContainer.propTypes = {
	formik: PropTypes.instanceOf(Array).isRequired,
};

export default SelectContainer;
